import { Module } from 'vuex'
import { GlobalDataProps, actionWrapper } from './index'
import { ListData } from './respTypes'

export interface BalanceData {
  // 本次转账的类型，初始送的金额/被推荐人付款的 20%/付款
  // initial / referrer / outcome
  type: string;
  // 转账操作类型，收入还是支持
  operation: 'ADD' | 'SUBTRACT';
  // 本次转账的金额
  amount: number;
  // 账户剩余的金额
  balance: number;
  // userId 数据库中 user 的关联 id，哪个用户的收益
  userId: string;
  // refUserId 数据库中 user 的关联 id，被推荐人的 ID，比如
  // Bob 推荐了 Alice，Alice 完成了付款，那么这里应该是 Alice 的 ID
  refUserId?: string;
  // 和 order 的关联 id
  orderId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BalanceProps {
  data: BalanceData[];
  count: number;
}

const balance: Module<BalanceProps, GlobalDataProps> = { 
  state: { 
    data: [],
    count: 0
  },
  mutations: {
    getBalanceAdmin(state, rawData: ListData<BalanceData[]>) {
      const { data, count } = rawData.data
      state.data = data
      state.count = count
    },
  },
  actions: { 
    getBalanceAdmin: actionWrapper('/api/balancesAdmin', 'getBalanceAdmin', { disableCaching: true }),
  }
}

export default balance